import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import {
    getBulkDropdownData,
    getDropdownData,
    getOtherRefDetails,
    getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import {
  deductionMasterValidation,
  itemCreationValidation,
} from "../../validations/DeductionCreation";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import { deductionItemById } from "../../../api/DeductionItemApi";
import { vehicleAssignmentSearch } from "../../../api/jobApi";
import useUserCompany from "../../../hooks/useUserCompany";
import {existsByDetStatusAndDetActiveAndDetDedId} from "../../../api/finance/deductionMasterApi";

const DeductionMasterForm = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    const today = new Date().toISOString().split("T")[0];

    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null
    );

    const [deductionMasterData, setDeductionMasterData] = useState(
      editMode
        ? {
            ...currentValues,
            dedId: currentValues.dedId,
            dedStart: currentValues.dedStart
              ? new Date(currentValues.dedStart).toISOString().slice(0, 10)
              : "",
            dedEnd: currentValues.dedEnd
              ? new Date(currentValues.dedEnd).toISOString().slice(0, 10)
              : "",
            dedExecutionDate: currentValues.dedExecutionDate
              ? new Date(currentValues.dedExecutionDate)
                  .toISOString()
                  .slice(0, 10)
              : "",
            dedWarrantyEnds: currentValues.dedWarrantyEnds
              ? new Date(currentValues.dedWarrantyEnds)
                  .toISOString()
                  .slice(0, 10)
              : "",
            dedReferenceStartDate: currentValues.dedReferenceStartDate
              ? new Date(currentValues.dedReferenceStartDate).toISOString().slice(0, 10)
              : "",
            dedReferenceEndDate: currentValues.dedReferenceEndDate
              ? new Date(currentValues.dedReferenceEndDate).toISOString().slice(0, 10)
              : "",
          }
        : {
            dedCode: "",
            dedReference: "",
            dedCompany: company,
            dedTransporter: "",
            dedVehicle: "",
            dedItem: "",
            dedItemType: "",
            dedPeriod: "",
            dedStart: "",
            dedEnd: "",
            dedRequiredDate: "",
            dedExecutionDate: "",
            dedItemCost: "",
            dedQuantity: 1,
            dedAmount: 0,
            dedInstallmentAmount: 0,
            dedInstallments: 1,
            dedPaymentStatus: 1,
            dedSerialNumber: "",
            dedDescription: "",
            dedWarranty: "",
            dedWarrantyEnds: "",
            dedJob: "",
            dedDistance: "",
            dedFuelInstruction: "",
            dedBehalfOf: "",
            dedApprovalLevels: "",
            dedStatus: 2,
            dedActive: 1,
            vehicleValue: "",
            dedTransName: "",
            dedSupplier: "",
            minToDate: today,
            dedReferenceStartDate: "",
            dedReferenceEndDate: "",
            dedRemark: ""
          }
    );

   
    const [itemType, setItemType] = useState(null);

    // flags
    const [fieldReset, setFieldReset] = useState(false);
    const [itemFieldReset, setItemFieldReset] = useState(false);
    const [installmentsDisable, setInstallmentsDisable] = useState(false);
    const [endDateDisable, setEndDateDisable] = useState(false);

    //errors
    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    // dropdown
    const [itemTypeOpt, setItemTypeOpt] = useState([]);
    const [itemOpt, setItemOpt] = useState([]);
    const [paymentStatusOpt, setPaymentStatusOpt] = useState([]);
    const [dedStatusOpt, setDedStatusOpt] = useState([]);
    const [dedActiveOpt, setDedActiveOpt] = useState([]);
    const [dedPeriodOpt, setDedPeriodOpt] = useState([]);

    const [executionDateGap, setExecutionDateGap] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(null);

    const [deductionApprovalStatus, setDeductionApprovalStatus] = useState(false);
    

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    useEffect(() => {
      (async () => {
          const {
              status,
              active,
              item_type:itemType,
              payment_status:paymentStatus,
              deduction_period:period
          } = await getBulkDropdownData([
              {key:"active"},
              {key:"status"},
              {key:"item_type"},
              {key:"payment_status"},
              {key:"deduction_period"},
          ]);
          setItemTypeOpt(itemType);
          setPaymentStatusOpt(paymentStatus);
          setDedStatusOpt(status);
          setDedActiveOpt(active);
          setDedPeriodOpt(period);
      })();
    }, []);

      useEffect(() => {
          (async () => {
              const response = await existsByDetStatusAndDetActiveAndDetDedId(currentValues?.dedId);
              setDeductionApprovalStatus(response);
          })();
      }, [currentValues]);

    useEffect(() => {
      (async () => {
        const itemData = await getOtherRefSearchDropdown({
          type: "item_type",
          value: deductionMasterData.dedItemType,
        });
        const updatedItemData = itemData.map((itemData) => {
          return {
            ...itemData,
            text: itemData.title,
          };
        });
        setItemOpt(updatedItemData);
      })();
      console.log("after vehicle add", deductionMasterData.dedTransporter);
    }, [deductionMasterData]);

    const setCostAgainstItem = async (data) => {
      const response = await deductionItemById(data);
      if (editMode) {
        setDeductionMasterData((prevState) => ({
          ...prevState,
          dedItemCost: response[0].temPrice,
          dedAmount: response[0].temPrice,
          dedInstallmentAmount: parseFloat(
            (
              (response[0].temPrice * deductionMasterData.dedQuantity) /
              deductionMasterData.dedInstallments
            ).toFixed(2)
          ),
        }));
      } else {
        setDeductionMasterData((prevState) => ({
          ...prevState,
          dedItemCost: response[0].temPrice,
          dedAmount: response[0].temPrice,
          dedQuantity: 1,
          dedInstallmentAmount: parseFloat(
            (
              (response[0].temPrice * deductionMasterData.dedQuantity) /
              deductionMasterData.dedInstallments
            ).toFixed(2)
          ),
        }));
      }
    };

    const handlePeriodResult = (id) => {
      setSelectedPeriod(id);
      if (id === 1) {
        const currentDate = new Date().toISOString().split("T")[0];
        setDeductionMasterData((prevState) => ({
          ...prevState,
          dedInstallments: 1,
          dedStart: currentDate,
          dedEnd: currentDate,
          dedExecutionDate: currentDate,
        }));
        setInstallmentsDisable(true);
      } else {
        setDeductionMasterData((prevState) => ({
          ...prevState,
          dedInstallments: "",
          dedStart: "",
          dedEnd: "",
          dedExecutionDate: "",
        }));
        setInstallmentsDisable(false);
      }
    };

    const handleInstallmentDates = (data) => {
      const selectedDate = new Date(data);
      const executionDate = new Date(data);
      if (selectedPeriod === 2) {
        selectedDate.setMonth(
          selectedDate.getMonth() +
            parseInt(deductionMasterData.dedInstallments)
        );
        const endOfMonth = new Date(
          executionDate.getFullYear(),
          executionDate.getMonth() + 1,
          1
        );
        setDeductionMasterData((prev) => ({
          ...prev,
          dedStart: data,
          dedEnd: selectedDate.toISOString().split("T")[0],
        }));
        setExecutionDateGap(endOfMonth.toISOString().split("T")[0]);
      } else if (selectedPeriod === 3) {
        const daysToAdd = parseInt(deductionMasterData.dedInstallments) * 7;
        executionDate.setDate(selectedDate.getDate() + 7);
        selectedDate.setDate(selectedDate.getDate() + daysToAdd);
        setDeductionMasterData({
          ...deductionMasterData,
          dedStart: data,
          dedEnd: selectedDate.toISOString().split("T")[0],
        });
        setExecutionDateGap(executionDate.toISOString().split("T")[0]);
      }

      setEndDateDisable(true);
    };

    const currentDate = deductionMasterData.dedStart;
    const maxDate = executionDateGap || "";

    useImperativeHandle(ref, () => ({
      getData: () => deductionMasterData,
      validateForm: () => {
        return deductionMasterValidation(deductionMasterData);
      },
      resetForm: () => {
        setDeductionMasterData({
            dedCode: "",
            dedReference: "",
            dedCompany: company,
            dedTransporter: "",
            dedVehicle: "",
            dedItem: "",
            dedItemType: "",
            dedPeriod: "",
            dedStart: "",
            dedEnd: "",
            dedRequiredDate: "",
            dedExecutionDate: "",
            dedItemCost: "",
            dedQuantity: 1,
            dedAmount: 0,
            dedInstallmentAmount: 0,
            dedInstallments: 1,
            dedPaymentStatus: 1,
            dedSerialNumber: "",
            dedDescription: "",
            dedWarranty: "",
            dedWarrantyEnds: "",
            dedJob: "",
            dedDistance: "",
            dedFuelInstruction: "",
            dedBehalfOf: "",
            dedApprovalLevels: "",
            dedStatus: 2,
            dedActive: 1,
            vehicleValue: "",
            dedTransName: "",
            dedSupplier: "",
            minToDate: today,
            dedReferenceStartDate: "",
            dedReferenceEndDate: "",
            dedRemark: ""
        });
          setFieldReset(true)
          setItemFieldReset(true)
        setCurrentErrors({});
      },
    }));
    const vehicleRef = useRef();
    const onVehicleSelect = (data) => {
      setDeductionMasterData((prevState) => ({
        ...prevState,
        dedVehicle: data.value,
        dedTransporter: data.transId,
        dedTransName: data.transporterName,
      }));
    };

    const checkEditAvailable = () => {
      if (editMode) {
        const executionDate = new Date(deductionMasterData.dedExecutionDate);
        const currentDate = new Date();

        const executionDateStr = executionDate.toISOString().slice(0, 10);
        const currentDateStr = currentDate.toISOString().slice(0, 10);

        return executionDateStr <= currentDateStr;
      }
      return false;
    };
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Add Deduction</h4>
              <div className="two fields">
                <Input
                  label="Deduction code"
                  error={currentErrors.dedCode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="dedCode"
                  value={deductionMasterData.dedCode}
                  onChange={(e) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
                <Input
                  label="Reference"
                  error={currentErrors.dedReference}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedReference: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="dedRef"
                  value={deductionMasterData.dedReference}
                  onChange={(e) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedReference: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Item Type"
                  error={currentErrors.dedItemType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedItemType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Item Type"
                  options={itemTypeOpt}
                  style={{ height: "20px" }}
                  value={deductionMasterData.dedItemType}
                  onChange={(e, data) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedItemType: data.value,
                    }));
                    setItemFieldReset(true);
                  }}
                  disabled={editMode}
                />
                <SearchDropdown
                  key={1}
                  required={true}
                  editMode={editMode}
                  reset={itemFieldReset}
                  setReset={setItemFieldReset}
                  clearable={true}
                  onClear={() => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedItem: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedItem: data,
                    }));
                    setCostAgainstItem(data);
                  }}
                  api={getOtherRefDetails}
                  apiDependency={{
                    type: "item_type",
                    value: deductionMasterData.dedItemType,
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_items",
                    primaryKey: "tem_id",
                    fieldName: "tem_name",
                    id: deductionMasterData.dedItem,
                  }}
                  label="Item"
                  error={currentErrors.dedItem}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedItem: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  disabled={checkEditAvailable()}
                />
              </div>
              <div className="three fields">
                <SearchDropdown
                  key={2}
                  required={true}
                  editMode={editMode}
                  reset={fieldReset}
                  setReset={setFieldReset}
                  returnFullObject={true}
                  clearable={true}
                  onClear={() => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedVehicle: null,
                      dedTransporter: null,
                      dedTransName: null,
                    }));
                  }}
                  // onResultSelect={onVehicleSelect}
                  onResultSelect={(data) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedVehicle: data.value,
                      dedTransporter: data.transId,
                      dedTransName: data.transporterName,
                    }));
                  }}
                  api={vehicleAssignmentSearch}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_vehicle_details",
                    primaryKey: "veh_id",
                    fieldName: "veh_vehicleno",
                    id: deductionMasterData.dedVehicle,
                  }}
                  apiDependency={{
                    lTransporter:
                      deductionMasterData.dedTransporter !== ""
                        ? deductionMasterData.dedTransporter
                        : null,
                    fullObject: true,
                  }}
                  label="Vehicle"
                  error={currentErrors.dedVehicle}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedVehicle: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  disabled={checkEditAvailable()}
                />

                <SearchDropdown
                  key={1}
                  required={true}
                  editMode={editMode}
                  reset={fieldReset}
                  setReset={setFieldReset}
                  clearable={true}
                  multiGrid={true}
                  multiGridCurrentValue={deductionMasterData.dedTransName}
                  onClear={() => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedTransporter: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedTransporter: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Transporter",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: deductionMasterData.dedTransporter,
                  }}
                  error={currentErrors.dedTransporter}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedTransporter: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Transporter"
                  disabled={checkEditAvailable()}
                />
                <SearchDropdown
                  key={1}
                  required={true}
                  editMode={editMode}
                  reset={fieldReset}
                  setReset={setFieldReset}
                  clearable={true}
                  onClear={() => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedSupplier: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedSupplier: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Supplier",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: deductionMasterData.dedSupplier,
                  }}
                  error={currentErrors.dedSupplier}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedSupplier: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Supplier"
                  disabled={checkEditAvailable()}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  label="Period"
                  required={true}
                  error={currentErrors.dedPeriod}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedPeriod: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Period"
                  options={dedPeriodOpt}
                  style={{ height: "20px" }}
                  value={deductionMasterData.dedPeriod}
                  onChange={(e, data) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedPeriod: data.value,
                    }));
                    handlePeriodResult(data.value);
                  }}
                  disabled={editMode}
                />
                <Input
                  label="Installments"
                  required={true}
                  disabled={editMode}
                  readOnly={installmentsDisable || selectedPeriod === 1}
                  error={currentErrors.dedInstallments}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedInstallments: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type={"number"}
                  min={0}
                  placeholder="Installments"
                  name="installments"
                  value={deductionMasterData.dedInstallments}
                  onChange={(e) => {
                    const installments = parseFloat(e.target.value) || 1;
                    const itemAmount = deductionMasterData.dedAmount || 0;
                    const quantity = deductionMasterData.dedQuantity || 1;
                    const amount = (itemAmount * quantity) / installments;

                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedInstallments: e.target.value,
                      dedStart: "",
                      dedEnd: "",
                      dedExecutionDate: "",
                      dedInstallmentAmount: parseFloat(amount.toFixed(2)),
                    }));
                  }}
                />
                `
              </div>
              <div className="three fields">
                <Input
                  required={selectedPeriod !== 1}
                  label="Start"
                  error={currentErrors.dedStart}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedStart: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="start"
                  placeholder="Start"
                  value={deductionMasterData.dedStart}
                  onChange={(e) => {
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedStart: e.target.value,
                    }));
                    handleInstallmentDates(e.target.value);
                  }}
                  min={deductionMasterData.minToDate}
                  disabled={editMode || deductionMasterData.dedInstallments === ""}
                  readOnly={selectedPeriod === 1}
                />

                <Input
                  required={selectedPeriod !== 1}
                  label="End"
                  error={currentErrors.dedEnd}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedEnd: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="end"
                  placeholder="End"
                  value={deductionMasterData.dedEnd}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedEnd: e.target.value,
                    }))
                  }
                  disabled={editMode}
                  readOnly={endDateDisable || selectedPeriod === 1}
                />

                <Input
                  required={selectedPeriod !== 1}
                  label="Execution Date"
                  error={currentErrors.dedExecutionDate}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedExecutionDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="ExecutionDate"
                  value={deductionMasterData.dedExecutionDate}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedExecutionDate: e.target.value,
                    }))
                  }
                  min={currentDate}
                  max={maxDate}
                  disabled={editMode}
                  readOnly={selectedPeriod === 1}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Amount"
                  step={0.01}
                  error={currentErrors.dedAmount}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedAmount: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type={"number"}
                  min={0}
                  placeholder="Amount"
                  name="amount"
                  value={deductionMasterData.dedAmount}
                  onChange={(e) =>{
                    const amount = parseFloat(e.target.value) || 0;
                    const installments = deductionMasterData.dedInstallments || 1;

                      const installmentAmount = amount / installments;
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedAmount: e.target.value,
                      dedInstallmentAmount: parseFloat(
                            installmentAmount.toFixed(2)
                        ),
                    }))
                  }}
                  disabled={checkEditAvailable()}
                />
                <Input
                  label="Installment Amount"
                  error={currentErrors.dedInstallmentAmount}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedInstallmentAmount: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  readOnly={true}
                  min={0}
                  placeholder="Installment Amount"
                  name="installmentAmount"
                  value={deductionMasterData.dedInstallmentAmount}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedInstallmentAmount: e.target.value,
                    }))
                  }
                  disabled={checkEditAvailable()}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Warranty (months)"
                  error={currentErrors.dedWarranty}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedWarranty: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Warranty (months)"
                  type={"number"}
                  min={0}
                  name="warranty"
                  value={deductionMasterData.dedWarranty}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedWarranty: e.target.value,
                    }))
                  }
                  disabled={checkEditAvailable()}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Warranty Ends"
                  error={currentErrors.dedWarrantyEnds}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedWarrantyEnds: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="start"
                  value={deductionMasterData.dedWarrantyEnds}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedWarrantyEnds: e.target.value,
                    }))
                  }
                  disabled={checkEditAvailable()}
                />
                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  reset={fieldReset}
                  setReset={setFieldReset}
                  clearable={true}
                  onClear={() => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedJob: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedJob: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "JOB",
                    param1: deductionMasterData.dedVehicle
                      ? deductionMasterData.dedVehicle
                      : "",
                  }}
                  fieldInfo={{
                    tableName: "transport.tms_t_job",
                    primaryKey: "job_id",
                    fieldName: "job_code",
                    id: deductionMasterData.dedJob,
                  }}
                  error={currentErrors.dedJob}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedJob: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Job"
                  disabled={
                    checkEditAvailable() ||
                    deductionMasterData.dedItemType !== 6 ||
                    deductionMasterData.dedItemType == null
                  }
                  required={editMode || deductionMasterData.dedItemType === 6}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  label="Status"
                  required={true}
                  error={currentErrors.dedStatus}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={dedStatusOpt}
                  style={{ height: "20px" }}
                  value={deductionMasterData.dedStatus}
                  onChange={(e, data) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedStatus: data.value,
                    }));
                  }}
                  disabled={true}
                />
                <Dropdown
                  label="Active"
                  required={true}
                  error={currentErrors.dedActive}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={dedActiveOpt}
                  style={{ height: "20px" }}
                  value={deductionMasterData.dedActive}
                  onChange={(e, data) => {
                    setDeductionMasterData((prevState) => ({
                      ...prevState,
                      dedActive: data.value,
                    }));
                  }}
                  disabled={editMode && deductionApprovalStatus}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Terminal Id"
                  error={currentErrors.dedSerialNumber}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedSerialNumber: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Terminal Id"
                  type={"text"}
                  name="serialNumber"
                  value={deductionMasterData.dedSerialNumber}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedSerialNumber: e.target.value,
                    }))
                  }
                  disabled={checkEditAvailable()}
                />
                <Input
                  label="Serial Number/Description"
                  error={currentErrors.dedDescription}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { dedDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Serial Number/Description"
                  name="description"
                  value={deductionMasterData.dedDescription}
                  onChange={(e) =>
                    setDeductionMasterData((prev) => ({
                      ...prev,
                      dedDescription: e.target.value,
                    }))
                  }
                  disabled={checkEditAvailable()}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Reference Start Date"
                  error={currentErrors.dedReferenceStartDate}
                  resetError={() =>
                      setCurrentErrors((prevState) => {
                          const { dedReferenceStartDate: _, ...rest } = prevState;
                          return rest;
                      })
                  }
                  type="date"
                  name="ReferenceStartDate"
                  placeholder="Reference Start Date"
                  value={deductionMasterData.dedReferenceStartDate}
                  onChange={(e) => {
                      setDeductionMasterData((prev) => ({
                          ...prev,
                          dedReferenceStartDate: e.target.value,
                          dedReferenceEndDate: ""
                      }));
                  }}
                  min={deductionMasterData.minToDate}
                />
                <Input
                  label="Reference End Date"
                  error={currentErrors.dedReferenceEndDate}
                  resetError={() =>
                      setCurrentErrors((prevState) => {
                          const { dedReferenceEndDate: _, ...rest } = prevState;
                          return rest;
                      })
                  }
                  type="date"
                  name="ReferenceEndDate"
                  placeholder="Reference End Date"
                  value={deductionMasterData.dedReferenceEndDate}
                  onChange={(e) => {
                      setDeductionMasterData((prev) => ({
                          ...prev,
                          dedReferenceEndDate: e.target.value,
                      }));
                  }}
                  min={deductionMasterData.dedReferenceStartDate}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Remark"
                  error={currentErrors.dedRemark}
                  resetError={() =>
                      setCurrentErrors((prevState) => {
                          const { dedRemark: _, ...rest } = prevState;
                          return rest;
                      })
                  }
                  placeholder="Remark"
                  name="remark"
                  value={deductionMasterData.dedRemark}
                  onChange={(e) =>
                      setDeductionMasterData((prev) => ({
                          ...prev,
                          dedRemark: e.target.value,
                      }))
                  }

                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: deductionMasterData.createdBy
                      ? deductionMasterData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: deductionMasterData.createdDate
                      ? formatFromJsonDate(deductionMasterData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: deductionMasterData.lastModifiedBy
                      ? deductionMasterData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: deductionMasterData.lastModifiedDate
                      ? formatFromJsonDate(deductionMasterData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  }
);
export default DeductionMasterForm;
